<script lang="ts">
	import arrowIcon from "@core/assets/icons/expand-b.svg?raw";
	import type { ProductCategory } from "@core/schema/ProductCategory.js";
	import type { ProductGroup } from "@core/schema/ProductGroup.js";
	import type { WebPartner } from "@core/schema/WebPartner.js";
	import { productGroupNameMap } from "@core/schema/names/productGroupNameMap.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";
	import LabelledInput from "./form/LabelledInput.svelte";
	import Searchbar from "./form/Searchbar.svelte";

	let {
		/* eslint-disable prefer-const */
		group,
		values,
		disabled,
		/* eslint-enable prefer-const */
		selected = $bindable(),
	}: { selected: string[]; disabled?: boolean } & (
		| { group: ProductGroup; values: ProductCategory[] }
		| { group?: undefined; values: WebPartner[] }
	) = $props();

	let search = $state("");
	const { tenant } = getGlobalTemplateProps();
	const filtered = $derived((values as ProductCategory[]).filter(({ productGroup }) => productGroup === group));

	const id = $props.id();
</script>

<details
	class={[
		"bg-white rounded-xl sm:rounded-3xl group aria-disabled:pointer-events-none",
		/* Opinion might change */ "aria-disabled:hidden",
	]}
	aria-disabled={disabled}
>
	<summary class="list-none cursor-pointer py-1 px-3 sm:p-4">
		<div class="flex justify-between py-1 items-center">
			<span class="text-xs/none sm:text-base font-semibold uppercase">
				{#if group === undefined}
					Partner
				{:else}
					{void (/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */ "ESLint is drunk???")}
					<Formatted text={productGroupNameMap[group][tenant.locale]} />
				{/if}
			</span>
			<Icon
				icon={arrowIcon}
				class="size-6 sm:size-8 rotate-180 group-open:rotate-0 transition-transform text-cmcprimary group-aria-disabled:text-cmcmidgray"
			/>
		</div>
	</summary>
	<div class="flex flex-col gap-4 sm:gap-6 py-1 px-3 sm:p-4 !pt-0 mt-3 sm:mt-2">
		{#if filtered.length > 0}
			<Searchbar placeholder="Napište, co hledáte…" class="w-full" bind:value={search} />
			<form>
				<div class="flex flex-col sm:gap-4">
					{#each filtered as category (category.id)}
						<LabelledInput
							wrapperClass={["mb-3 sm:mb-0", !category.name.toLowerCase().includes(search.toLowerCase()) && "hidden"]}
							type="checkbox"
							name={id}
							checked={selected.includes(category.id)}
							onchange={({ currentTarget: { checked = false } }): void => {
								if (checked) {
									selected.push(category.id);
								} else {
									selected = selected.filter((id) => id !== category.id);
								}
							}}
						>
							{category.name}
						</LabelledInput>
					{/each}
				</div>
			</form>
		{/if}
	</div>
</details>
